import _extends from '@babel/runtime/helpers/extends';
import { __rest } from '../../../dependencies/tslib/tslib.es6.js';
import './Link.scss.js';
import React__default from 'react';
import { classnames } from '../../../utils/classnames.js';

var Link = function Link(_a) {
  var component = _a.component,
      children = _a.children,
      _a$color = _a.color,
      color = _a$color === void 0 ? 'primary' : _a$color,
      _a$size = _a.size,
      size = _a$size === void 0 ? 'md' : _a$size,
      startAdornment = _a.startAdornment,
      endAdornment = _a.endAdornment,
      className = _a.className,
      props = __rest(_a, ["component", "children", "color", "size", "startAdornment", "endAdornment", "className"]);

  var Component = component || 'a';
  return /*#__PURE__*/React__default.createElement(Component, _extends({
    "data-testid": "rf-link",
    className: classnames('rf-link', "rf-link--".concat(color), "rf-link--".concat(size), className)
  }, props, {
    "data-v-6e52f9c7": ""
  }), !!startAdornment && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-link__adornment rf-link__adornment--start",
    "data-v-6e52f9c7": ""
  }, startAdornment), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children), !!endAdornment && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-link__adornment rf-link__adornment--end",
    "data-v-6e52f9c7": ""
  }, endAdornment));
};

export { Link };
